module.exports = __webpack_public_path__ + "img/logo.8587af96.svg";